import $ from 'jquery';

window.addEventListener('load', function(event) {

  $("input[name^='dealer_type']").change(function () {
    let self = this;
    $(this).closest('.js-radios').each(function () {
      $(this).find('input:radio').attr('checked', false);
      $(self).attr('checked', true);
    });
  });

});
